import { put } from "redux-saga/effects";

import * as userActions from "./actions";
import { defaultApi, apiCall } from "app/states/api";
import { IHttpClientData, ResponseStatus } from "app/services/default";

export function* login(action: ReturnType<typeof userActions.getUsersAsync.request>): Generator {
    try {
        const response: any = yield apiCall(defaultApi.auth.login, action.payload);
        const IApiResponse: IHttpClientData = response;

        if (IApiResponse.status === ResponseStatus.Sucess) {
            yield put(userActions.getUsersAsync.success(IApiResponse.data));
        } else {
            yield put(userActions.getUsersAsync.failure(IApiResponse.message));
        }
    } catch (ex) {
        yield put(userActions.getUsersAsync.failure(ex.message));
    }
}
